import { render } from "./nestedOptionFieldItem.vue?vue&type=template&id=24cefd04&scoped=true"
import script from "./nestedOptionFieldItem.vue?vue&type=script&lang=js"
export * from "./nestedOptionFieldItem.vue?vue&type=script&lang=js"

import "./nestedOptionFieldItem.vue?vue&type=style&index=0&id=24cefd04&scoped=true&lang=css"

import exportComponent from "/Users/andrew/Documents/Code/SeoBiz/AdminApp/FrontEnd/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24cefd04"]])

export default __exports__